"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewDataCategory extends new_item_1.default {
    constructor(newDataCategory) {
        super();
        this.name = newDataCategory.name;
        this.organisationId = newDataCategory.organisationId;
        this.color = newDataCategory.color;
        this.icon = newDataCategory.icon;
        this.global = newDataCategory.global;
        this._permission = newDataCategory._permission;
    }
}
exports.default = NewDataCategory;
//# sourceMappingURL=new-dataCategory.js.map